import { render, staticRenderFns } from "./echart-pie.vue?vue&type=template&id=f3d1cef8&scoped=true"
import script from "./echart-pie.vue?vue&type=script&lang=js"
export * from "./echart-pie.vue?vue&type=script&lang=js"
import style0 from "./echart-pie.vue?vue&type=style&index=0&id=f3d1cef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d1cef8",
  null
  
)

export default component.exports